/**
 * Shrinks announcement bar text just enough to keep it on a single line.
 * Only scales down when the text would otherwise wrap, so short announcements
 * stay at their full size. Falls back to wrapping if the minimum size still
 * overflows, so nothing is ever clipped.
 */
(function () {
  const SAFETY = 0.99;

  function fitOne(text) {
    if (!text || !text.isConnected) return;

    text.style.fontSize = '';
    text.style.whiteSpace = 'nowrap';

    const base = parseFloat(getComputedStyle(text).fontSize);
    if (!base) return;

    const section = text.closest('.announcement-bar');
    const minSize = section ? parseFloat(section.dataset.fitMinSize) || 11 : 11;

    const available = text.clientWidth;
    const needed = text.scrollWidth;
    if (!available || needed <= available) return;

    const scaled = Math.max(minSize, (base * available) / needed * SAFETY);
    text.style.fontSize = scaled + 'px';

    // Still too wide even at the minimum size - let it wrap rather than clip.
    if (text.scrollWidth > text.clientWidth + 1) {
      text.style.whiteSpace = '';
    }
  }

  function fitAll() {
    document.querySelectorAll('.announcement-bar[data-fit-text] .announcement-bar__text').forEach(fitOne);
  }

  let frame;
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
})();
